import { Target, Users, Award, MapPin } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-slate-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div data-testid="about-content">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600 mb-4 block">
              About Ashvya Digital Media
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-6">
              Your Growth Partner in Digital Marketing
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              Based in <strong>Modinagar, Ghaziabad</strong>, Ashvya Digital Media is your trusted partner for digital marketing excellence. We specialize in creating viral marketing campaigns that deliver real business growth.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              With successful campaigns across <strong>Noida, Greater Noida, Delhi NCR</strong>, and other metropolitan cities, we've helped businesses in real estate, healthcare, hospitality, and more achieve remarkable results.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              Our rapid growth strategies combine data-driven insights with creative excellence to make your brand stand out in the crowded digital landscape.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6" data-testid="about-features">
            <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300" data-testid="feature-expertise">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                <Target className="w-6 h-6 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Strategic Approach</h3>
              <p className="text-slate-600">Data-driven marketing strategies tailored to your goals</p>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300" data-testid="feature-clients">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">100+ Clients</h3>
              <p className="text-slate-600">Trusted by businesses across industries</p>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300" data-testid="feature-results">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                <Award className="w-6 h-6 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Proven Results</h3>
              <p className="text-slate-600">Track record of viral campaigns and growth</p>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300" data-testid="feature-location">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                <MapPin className="w-6 h-6 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Local Expertise</h3>
              <p className="text-slate-600">Deep understanding of NCR market</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;